import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Notification {
    _id: string;
    userId: string;
    title: string;
    body: string;
    text: string;
    status: string;
    createdAt: string;
}

interface NotificationState {
    notifications: Notification[];
}

const initialState: NotificationState = {
    notifications: [],
};

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {

        addNotification: (state, action: PayloadAction<Notification[]>) => {
            state.notifications = action.payload; // Replace old notifications
        },

        clearNotifications: (state) => {
            state.notifications = [];
        },
    },
});

export const { addNotification, clearNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
